<template>
    <div class="night-mode-clock d-flex align-center mr-4">
        <div class="clock-display mr-3">
            <v-icon small color="white" class="mr-1">mdi-clock-outline</v-icon>
            <span class="clock-time">{{ currentTime }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NightModeClock',
    data() {
        return {
            currentTime: '',
            clockInterval: null
        }
    },
    mounted() {
        this.startClock();
    },
    beforeDestroy() {
        this.stopClock();
    },
    methods: {
        updateClock() {
            const now = new Date();
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            this.currentTime = `${hours}:${minutes}:${seconds}`;
        },
        startClock() {
            this.updateClock();
            this.clockInterval = setInterval(() => {
                this.updateClock();
            }, 1000);
        },
        stopClock() {
            if (this.clockInterval) {
                clearInterval(this.clockInterval);
                this.clockInterval = null;
            }
        }
    }
}
</script>

<style scoped>
.night-mode-clock {
    height: 100%;
}

.clock-display {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}

.clock-time {
    color: white;
    font-weight: 600;
    font-size: 14px;
    font-family: 'Courier New', monospace;
}
</style>

